import React, { useEffect, useRef, useState } from "react"
import { FieldError } from "react-hook-form"
import { InputText } from "src/shared/components/forms"
import Icon from "src/shared/icons"
import { validateOnlyNumbers } from "src/shared/sections/payment/Payment.helpers"
import { useGetEasyrewardsLazyQuery } from "src/gql/schema"
import "./LovePointsInput.css"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { useModulos } from "src/shared/hooks/useModulos"

interface LovePointsInputProps {
    onChange: (amount: { id: string; saldo: number } | null) => void
    value?: { id: string; saldo: number }
    className?: string
    totalCost: number
    required
    error?: FieldError
    openModalMixto: () => void
}

const LovePointsInput: React.FC<LovePointsInputProps> = ({
    onChange,
    value,
    className,
    totalCost,
    openModalMixto,
    required,
    error
}) => {
    const [search, setSearch] = useState<string>("")
    const [canCheckBalance, setcanCheckBalance] = useState<boolean>(false)
    const { easyRewards: withEasyrewards } = useModulos()

    const [getEasyrewards, { data, loading }] = useGetEasyrewardsLazyQuery()

    const timerRef = useRef<NodeJS.Timer>()
    useEffect(() => {
        clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => {
            if (search.length >= 1 && search.length <= 5) {
                getEasyrewards({ variables: { easyrewards_id: search } })
            }
        }, 300)
    }, [search])

    useEffect(() => {
        if (value) {
            onChange({ id: value?.id, saldo: value?.saldo })
            setcanCheckBalance(true)
        }
    }, [])

    useEffect(() => {
        if (!data) return
        if (data?.obten_saldo?.saldo !== null && data?.obten_saldo?.saldo !== undefined) {
            onChange({ id: search.slice(0, 5), saldo: data?.obten_saldo?.saldo ?? 0 })
            setcanCheckBalance(true)
        } else {
            setcanCheckBalance(false)
        }
    }, [data])

    const { showSnackbar } = useSnackbar()

    const handleCheckBalance = () => {
        if (!canCheckBalance) {
            return
        }
        if (typeof value?.id !== "string" || value?.id.trim().length === 0) return

        if (!value?.saldo || !value?.id) return

        if (value.saldo === 0) {
            showSnackbar({
                status: "error",
                title: "Saldo insuficiente",
                text: "Tu saldo actual de Love Points es insuficiente. Actualmente tienes **0 puntos** disponibles. Intenta con otro método de pago."
            })
            return
        }
        if (value.saldo >= totalCost) {
            return
        }
        openModalMixto()
    }

    return (withEasyrewards &&
        <div className="lovepoints__input__wrapper">
            <InputText
                loader={loading}
                icon={Icon}
                iconProps={{
                    color: "var(--header-dark)",
                    height: 16,
                    width: 16,
                    name: "iconHash",
                }}
                inputWrapperClass={className ? "love-points__input--fluid" : "love-points__input"}
                label="Número de membresía"
                type="text"
                placeholder="Máximo 5 dígitos"
                value={value?.id || ""}
                onChange={(e) => {
                    const newValue = e.target.value
                    if (validateOnlyNumbers(newValue, 5)) {
                        onChange({ saldo: 0, id: newValue })
                        setSearch(newValue)
                    } 
                }}
                error={(required && !value?.id?.length)}
                errorhinttext={(required && !value?.id?.length) ? "Campo obligatorio" : ""}
            />
            <div className="lovepoints__input__consultar-saldo">
                <span
                    className="detalle-compra__consultar-saldo__link"
                    onClick={handleCheckBalance}
                    style={{
                        cursor: (!canCheckBalance || loading) ? "not-allowed" : "pointer",
                        opacity: (!canCheckBalance || loading) ? 0.5 : 1,
                    }}
                >
                    Consultar saldo
                </span>
            </div>
        </div>
    )
}

export default LovePointsInput
